import React from "react";
import useAuthorization from "../auth/useAuthorization";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";
import EinstellungColumn from "./EinstellungColumn";
import EinstellungenStandorte from "./EinstellungenStandorte";
import EinstellungenFunkkennungen from "./EinstellungenFunkkennungen";
import EinstellungenFahrzeuge from "./EinstellungenFahrzeuge";
import EinstellungenMangelKat from "./EinstellungenMangelKat";

const Einstellungen = () => {
  const {isAdmin} = useAuthorization();

  if (isAdmin) {
    return (
      <Container>
        <Row>
          <Col xs={6}>
            <EinstellungenFahrzeuge title="Fahrzeuge" bg="#dedede" color="" />
          </Col>
          <Col xs={3}>
            <EinstellungenFunkkennungen
              title="Funkkennungen"
              bg="#dedede"
              color=""
            />
          </Col>
          <Col xs={3}>
            <EinstellungenStandorte title="Standorte" bg="#dedede" color="" />
          </Col>
          <Col xs={3}>
            <EinstellungenMangelKat
              title="Kategorien (Mangel)"
              bg="#dedede"
              color=""
            />
          </Col>
        </Row>
      </Container>
    );
  } else {
    return <Container>Für dich gibt es hier nichts zu sehen :)</Container>;
  }
};

export default Einstellungen;
